import React from 'react';
import { compose } from 'redux';
import { withShowHide } from '@sparefoot/react-core/decorators';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Container } from 'components/core/Page';
import { Menu } from 'components/brand/Menu';
import { Link } from 'components/core/Link';
import { ClickToCall } from 'components/facility/ClickToCall';
import Logo from 'components/svg/Logo';
import CaretDown from 'components/svg/CaretDown';
import { phonePropType } from 'config/propTypes';
import { COLOR_BLUE, COLOR_SECONDARY_BLUE } from 'config/colors';

import './Header.scss';
import { Checkbox } from '@sparefoot/react-core';

export const enhance = compose(
	withShowHide('navigation'),
	withShowHide('owners'),
);

export function Header({
	navigationShowing,
	onToggleNavigation,
	phone,
	getTollfreePhoneNumber,
	onToggleOwners,
	ownersShowing,
	onSetOwners,
	onSetNavigation,
}) {
	return (
		<header className="site-header">
			<nav className="navbar">
				<Container>
					<Link
						to="/"
						className="logo-link"
					>
						<Logo />
					</Link>
					<div className="nav-right">
						<div className="menu-item">
							{}
							<label
								className={classnames(
									'menu-link dropdown-toggle owners-dropdown-menu ss-link',
									{ open: ownersShowing },
								)}
								htmlFor="owners-checkbox"
								aria-expanded={ownersShowing}
								aria-haspopup="true"
							>
								<Checkbox
									onChange={onToggleOwners}
									key="Owners Dropdown"
									id="owners-checkbox"
									name="owners-checkbox"
									className="visually-hidden"
									checked={ownersShowing}
								/>
								Owners{' '}
								<CaretDown
									fill={
										ownersShowing
											? COLOR_SECONDARY_BLUE
											: COLOR_BLUE
									}
								/>
							</label>
							<div>
								<ul
									className={classnames(
										'dropdown-menu',
										ownersShowing && 'showing',
									)}
								>
									<li className="menu-item">
										<Link
											className="menu-link"
											href="https://www.storable.com/products/marketplace/"
											rel="noopener noreferrer"
										>
											Add Your Facility
										</Link>
									</li>
									<li className="menu-item">
										<Link
											className="menu-link"
											href="https://argus-selfstorage.com/"
											rel="noopener noreferrer"
										>
											Buy & Sell Facilities
										</Link>
									</li>
								</ul>
							</div>
						</div>
						<div className="menu-item">
							<Link
								className="menu-link"
								href="https://www.storable.com/products/marketplace/"
								rel="noopener noreferrer"
							>
								Add Your Facility
							</Link>
						</div>
						<ClickToCall
							phone={phone}
							onFetchNumber={getTollfreePhoneNumber}
							phoneIcon={false}
						/>

						{}
						<label
							className={classnames('nav-button', {
								'open-menu': navigationShowing,
							})}
							htmlFor="menu-toggle-button"
						>
							<span className="icon-bars">
								<span className="visually-hidden">
									Open Navigation
								</span>
							</span>

							<Checkbox
								onChange={onToggleNavigation}
								key="menu-toggle-button"
								id="menu-toggle-button"
								name="menu-toggle-button"
								className="visually-hidden"
								checked={navigationShowing}
							/>
						</label>
					</div>
					<Menu
						ownersShowing={ownersShowing}
						onToggleOwners={onToggleOwners}
						onSetOwners={onSetOwners}
						onCloseNavigation={
							onSetNavigation
								? () => onSetNavigation(false)
								: undefined
						}
					/>
				</Container>
			</nav>
		</header>
	);
}

Header.propTypes = {
	navigationShowing: PropTypes.bool.isRequired,
	onToggleNavigation: PropTypes.func.isRequired,
	phone: phonePropType,
	getTollfreePhoneNumber: PropTypes.func.isRequired,
	onToggleOwners: PropTypes.func.isRequired,
	ownersShowing: PropTypes.bool.isRequired,
	onSetOwners: PropTypes.func.isRequired,
	onSetNavigation: PropTypes.func,
};

export default React.memo(enhance(Header));
